import React, {useEffect, useMemo, useState} from 'react'
import useQueryPostList from '../../../../hooks/api/post/useQueryPostList'
import {IPostList} from '../../../../apis/post/getPostList'
import RecommendPostTable from './RecommendPostTable'
import RecommendPostSearchContainer from './RecommendPostSearchContainer'
import WizPagination from '../../../../components/pagination/WizPagination'

interface IProps {
    className?: string
    getNextRank?: () => Promise<number>
    onPinned?: () => void
}

const RecommendPostContainer: React.FC<IProps> = ({className, getNextRank, onPinned}) => {
    const [searchWord, setSearchWord] = useState('')
    const [currentPage, setCurrentPage] = useState(1)
    const {data, refetch} = useQueryPostList(searchWord, 5, currentPage)

    const postList = useMemo(() => {
        let list: IPostList[] = []
        data?.data?.map(item => list.push(item))
        return list
    }, [data])

    useEffect(() => {
        refetch()
    }, [searchWord, data])

    useEffect(() => {
        refetch()
    }, [currentPage])

    return (
        <div className={`${className}`}>
            <RecommendPostSearchContainer onClick={e => setSearchWord(e)} />
            <RecommendPostTable
                data={postList}
                className={'mt-[30px]'}
                getNextRank={getNextRank}
                onPinned={onPinned}
            />
            <WizPagination
                totalPage={data?.pageInfo?.total_count}
                currentPage={currentPage}
                onPageChange={item => setCurrentPage(item)}
            />
        </div>
    )
}

export default RecommendPostContainer
